import React from "react";
import MaterialUiPhoneNumber from "material-ui-phone-number";
import countryCodeList from "../../../constants/e164_country_codes.json";

export default function PhoneField(props) {

  const renderValue = () => (props.value ?
    `${props.value.countryCode?.dialCode}${props.value.phone}` :
    undefined);


  const onChange = (value, countryCode) => {
    const backendCountryCode = countryCodeList.find(({ dialCode, isoCode }) =>
      dialCode === `+${countryCode.dialCode}` && isoCode === countryCode.countryCode);
    const val = () => {
      if (!!props.value?.countryCode?.dialCode && (backendCountryCode.dialCode !== props.value?.countryCode?.dialCode)) {
        return undefined;
      }
      return value.replace(backendCountryCode.dialCode, "");
    };
    let newVar = {
      countryCode: backendCountryCode,
      phone: val(),
    };
    props.onChange(newVar);
  };
  return (
    <MaterialUiPhoneNumber
      defaultCountry={"us"}
      autoFormat={false}
      countryCodeEditable={false}
      disableAreaCodes
      label={props.label}
      placeholder={props.label}
      error={props.touched && props.invalid}
      helperText={props.helperText}
      {...props}
      value={renderValue()}
      onChange={(value, countryCode) => onChange(value, countryCode)}
      onBlur={() => {
      }}
    />
  );
}
